import { useMemo } from 'react'
import { Select } from 'peach/components'
import { useInternalEmployeesGet } from 'core/types'
import { useCompanyInfo } from 'core/stores/bootstrap'
import { getName } from 'peach/helpers'
import _ from 'lodash'

const CompanyEmployeeSelect = (props) => {
  const company = useCompanyInfo()
  const companyId = props.companyId || company.id

  const { data: employees = [], isLoading } = useInternalEmployeesGet({
    companyId,
    query: { limit: 100 },
  })

  const options = useMemo(() => {
    return _.map(employees, (employee) => ({
      value: employee.id,
      label: getName(employee),
    }))
  }, [employees])

  return (
    <Select
      label='Employee'
      options={options}
      loading={isLoading}
      disabled={isLoading || !companyId}
      {...props}
    />
  )
}

export default CompanyEmployeeSelect
